import { notificationConstant } from "../_constants";

export default function notification(state = {}, action) {
    switch (action.type) {

        case notificationConstant.GET_USER_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case notificationConstant.GET_USER_LIST_SUCCESS:
            return {
                ...state,
                user: action?.customer?.data,
                loading: false,
                error: false
            }
        case notificationConstant.GET_USER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }


        case notificationConstant.GET_NOTIFICATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case notificationConstant.GET_NOTIFICATION_LIST_SUCCESS:
            return {
                ...state,
                notificationList: action?.customer?.data?.list,
                notificationTotal: action?.customer?.data?.total,

                loading: false,
                error: false
            }
        case notificationConstant.GET_NOTIFICATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }




        default:
            return state
    }
}